import { render, staticRenderFns } from "./UiCard.vue?vue&type=template&id=11f499ae&scoped=true&"
import script from "./UiCard.vue?vue&type=script&lang=js&"
export * from "./UiCard.vue?vue&type=script&lang=js&"
import style0 from "./UiCard.vue?vue&type=style&index=0&id=11f499ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f499ae",
  null
  
)

/* custom blocks */
import block0 from "./UiCard.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports